export const setData: any = {
  simple_reaction_1:"🙂",
  simple_reaction_2:"❌",
  simple_reaction_3:"✋",
};
